import { useDateFnsFormatString } from "Infrastructure/Hooks/DateFns/useDateFnsFormatString";
import { Typography } from "@mui/material";
import { format, isValid, parseISO } from "date-fns";
import type { FC } from "react";

interface DateCellProps {
  value?: string | null;
  fallbackText: string;
}

export const DateCell: FC<DateCellProps> = ({ value, fallbackText }) => {
  const dateFormat = useDateFnsFormatString();

  if (!value) {
    return <Typography variant="body2">{fallbackText}</Typography>;
  }

  try {
    const date = parseISO(value);
    const formattedDate = isValid(date) ? format(date, dateFormat) : value;
    return <Typography variant="body2">{formattedDate}</Typography>;
  } catch {
    // Fallback if parseISO throws an error for a malformed string
    return <Typography variant="body2">{value}</Typography>;
  }
};
